import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import 'vant/lib/index.css'
import 'element-plus/dist/index.css'
import './assets/public.css'

import mitt from 'mitt'

// import  VConsole  from  'vconsole';
// const vConsole = new VConsole();

import createFingerprint from './util/getDuid'
createFingerprint()

const app = createApp(App)
app.config.globalProperties.$mitt = new mitt()

app.use(createPinia())
app.use(router)

app.mount('#app')
